import React, {useState} from "react";
import {Button, Checkbox, App} from "antd";
import SVGHeader from '../../svg/SVGHeader'
import SVGCard from '../../svg/SVGCard'
import SVGCopyClipboard from '../../svg/SVGCopyClipboard'
import SVGClock from '../../svg/SVGClock'
import SVGStatusDoneLight from '../../svg/SVGStatusDoneLight'
import SVGStatusDoneDark from '../../svg/SVGStatusDoneDark'
import SVGStatusFailDark from '../../svg/SVGStatusFailDark'
import SVGStatusFailLight from '../../svg/SVGStatusFailLight'
import SVGArrowBack from '../../svg/SVGArrowBack'
import CountdownTimer from './countdown';

const PaymentInfo = ({data, themeColor}) => {
    const {notification} = App.useApp();

    const [nextScreen, setNextScreen] = useState(false);
    const [disableBtn, setDisableBtn] = useState(true);
    const [checked, setChecked] = useState(false);
    const updateDisableBtn = d => setDisableBtn(d);

    const copyToClipboard = (value) => {
        navigator.clipboard.writeText(value);

        notification.success({
            message: 'Скопійовано',
            placement: 'topRight',
            style: {
                backgroundColor: '#95de64',
                borderRadius: 5,
            },
        });
    }

    return <div className="paymentInfo">
        <header>
            {SVGHeader}
            <b>{data?.iban?.recipientIban ? 'Оплата IBAN' : 'Оплата P2P'}</b>
        </header>
        {data?.status === 'DONE' ? <>
            <main style={{textAlign: 'center'}}>
                <div style={{margin: '20px 0'}}>
                    {themeColor === 'light' ? SVGStatusDoneLight : SVGStatusDoneDark}
                </div>
                <b>Ваш переказ успішно здійснено</b>
            </main>
            <footer>
                <div className="footerInfo" style={{textAlign: 'center'}}>Дякуємо за використання нашого сервісу</div>
            </footer>
        </> : <>
            {data?.status === 'CANCELED' ? <>
                <main style={{textAlign: 'center'}}>
                    <div style={{margin: '20px 0'}}>
                        {themeColor === 'light' ? SVGStatusFailLight : SVGStatusFailDark}
                    </div>
                    <b>Ваша заявка скасована</b>
                </main>
                <footer>
                    <div className="footerInfo" style={{textAlign: 'center'}}>Дякуємо за використання нашого сервісу
                    </div>
                </footer>
            </> : <>
                {!nextScreen ? <>
                    <main>
                        <p className="title">Переказ коштів</p>
                        {data?.iban?.recipientIban ? <>
                            <div className="item">
                                <span>Час на оплату:</span>
                                <div>
                                    <b>
                                        <CountdownTimer dateCreate={data.dateCreate} countdownStartFromMinutes={3}/>
                                    </b>
                                    <Button className="clockBtn">{SVGClock}</Button>
                                </div>
                            </div>
                            <div className="item">
                                <span>Власник рахунку:</span>
                                <div><b className="bank">{data?.iban.recipientName}</b> <Button
                                    onClick={() => copyToClipboard(data?.iban.recipientName)}>{SVGCopyClipboard}</Button>
                                </div>
                            </div>
                            <div className="item">
                                <span>Сума платежу:</span>
                                <div><b>{data?.amount} {data?.currency}</b> <Button
                                    onClick={() => copyToClipboard(data?.amount)}>{SVGCopyClipboard}</Button></div>
                            </div>
                            <div className="item">
                                <span>IBAN:</span>
                                <div><b>{data?.iban.recipientIban}</b> <Button
                                    onClick={() => copyToClipboard(data?.iban.recipientIban)}>{SVGCopyClipboard}</Button>
                                </div>
                            </div>
                            <div className="item">
                                <span>INN:</span>
                                <div><b>{data?.iban.recipientTaxId}</b> <Button
                                    onClick={() => copyToClipboard(data?.iban.recipientTaxId)}>{SVGCopyClipboard}</Button>
                                </div>
                            </div>
                            <div className="item">
                                <span>Призначення:</span>
                                <div><b>{data?.iban.paymentPurpose}</b> <Button
                                    onClick={() => copyToClipboard(data?.iban.paymentPurpose)}>{SVGCopyClipboard}</Button>
                                </div>
                            </div>
                        </> : <>
                            {data?.bank && data?.card && <div className="item">
                                <span>Метод оплати:</span>
                                <b className="bank">{data?.bank}</b>
                            </div>}
                            {data.dateCreate && <div className="item">
                                <span>Час на оплату:</span>
                                <div>
                                    <b><CountdownTimer dateCreate={data.dateCreate} countdownStartFromMinutes={3}/></b>
                                    <Button className="clockBtn">{SVGClock}</Button>
                                </div>
                            </div>}
                            {data?.amount && <div className="item">
                                <span>Сума платежу:</span>
                                <div>
                                    <b>{data?.amount} {data?.currency}</b>
                                    <Button
                                        onClick={() => copyToClipboard(data?.amount)}>{SVGCopyClipboard}</Button>
                                </div>
                            </div>}
                            {data?.card && <div className="card">
                                <div className="cardIcon">{SVGCard} Карта отримувача</div>
                                <div className="cardNumber">
                                    {data?.card.replace(/(\d{4})(?=\d)/g, '$1 ')}
                                    <Button onClick={() => copyToClipboard(data?.card)}>{SVGCopyClipboard}</Button>
                                </div>
                                <div className="cardInfo">Перекажіть суму на вказану карту</div>
                            </div>}
                            {data?.reference && <div className="link">
                                <a href={data?.reference} target="_blank" rel="noreferrer">{data?.reference}</a>
                                <Button
                                    onClick={() => copyToClipboard(data?.reference)}>{SVGCopyClipboard}</Button>
                            </div>}
                        </>}
                    </main>
                    <footer>
                        <Button disabled={disableBtn} onClick={() => setNextScreen(true)}>Продовжити</Button>
                        <div><Checkbox
                            checked={checked}
                            onChange={e => {
                                updateDisableBtn(!e.target.checked);
                                setChecked(e.target.checked)
                            }}>Я здійснив(ла) переказ (одним платежем)</Checkbox></div>
                        <div className="footerInfo">Враховуйте комісію вашого банку. Переказ суми, що не відповідає
                            зазначеній,
                            може
                            призвести до затримки
                            зарахування коштів або їх втрати
                        </div>
                    </footer>
                </> : <>
                    <main style={{textAlign: 'center'}}>
                        <p className="title">Ваша заявка в обробці</p>
                        <section>
                            {SVGClock}
                            <div>
                                <b style={{fontSize: '22px'}}>
                                    <CountdownTimer
                                        dateCreate={data.dateCreate}
                                        countdownStartFromMinutes={5}
                                    />
                                </b>
                            </div>
                        </section>
                    </main>
                    <footer style={{textAlign: 'center'}}>
                        <div className="footerInfo">Після успішної перевірки вашу заявку буде схвалено</div>
                    </footer>
                    <Button className="onBack" onClick={() => setNextScreen(false)}>{SVGArrowBack} Повернутись
                        назад</Button>
                </>}
            </>}
        </>}
    </div>
}

export default PaymentInfo;